import * as React from 'react';
import User, { UserOktaStatus } from '../../../../models/user';
import TertiaryButton from '../../../common/tertiary-button';
import { useHistory } from 'react-router';
import Paths from '../../../../models/enums/paths';

interface Props {
  user: User;
}
const ClientUserEntry = ({ user }: Props) => {
  const history = useHistory();

  const redirectToEditUserId = (userId: string) => {
    history.push(Paths.EditUser.replace(':userId', userId));
  };

  return (
    <tr>
      <td>
        {user.lastName}, {user.firstName}
      </td>
      <td>{user.role}</td>
      <td title={user.email}>{user.email}</td>
      <td title={user.department}>{user.department}</td>
      <td>{UserOktaStatus[user.status] === 'Active' ? 'ACTIVE' : 'INACTIVE'}</td>
      <td>
        <TertiaryButton text="Edit User" title="Edit User" handleClick={() => redirectToEditUserId(user.id)} />
      </td>
    </tr>
  );
};

export default ClientUserEntry;
